import { Reveal, Overline } from "@/components/Kinetic";
import { useLang } from "@/i18n/LanguageContext";

const ITEMS_EN = [
  {
    title: "AI-native product development",
    text: "Models are part of the product architecture, not an add-on.",
  },
  {
    title: "Data-driven systems",
    text: "Products are built on structured data pipelines designed for accuracy and traceability.",
  },
  {
    title: "Cloud infrastructure",
    text: "Modern, managed infrastructure that scales with the product and stays out of the way.",
  },
  {
    title: "Secure multi-tenant architecture",
    text: "Isolation, access control and data protection designed in from the start.",
  },
];

const ITEMS_TR = [
  {
    title: "Yapay zekâ odaklı ürün geliştirme",
    text: "Modeller ürün mimarisinin parçasıdır, sonradan eklenen bir eklenti değil.",
  },
  {
    title: "Veri odaklı sistemler",
    text: "Ürünler, doğruluk ve izlenebilirlik için tasarlanmış yapılandırılmış veri hatları üzerine kurulur.",
  },
  {
    title: "Bulut altyapısı",
    text: "Ürünle birlikte ölçeklenen ve yoldan çekilen modern, yönetilen altyapı.",
  },
  {
    title: "Güvenli çok kiracılı mimari",
    text: "Yalıtım, erişim kontrolü ve veri koruması en baştan tasarlanır.",
  },
];

const STACK = ["Next.js", "TypeScript", "Supabase", "Vercel", "Modern AI infrastructure"];

export default function TechnologySection() {
  const { lang, tx } = useLang();
  const items = lang === "tr" ? ITEMS_TR : ITEMS_EN;

  return (
    <section id="technology" className="bg-ink py-20 text-slate-300 sm:py-28 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Overline dark>{tx("Engineering", "Mühendislik")}</Overline>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-6 max-w-2xl font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl">
            {tx(
              "Built like a technology company.",
              "Bir teknoloji şirketi gibi inşa ediyoruz.",
            )}
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-slate-400">
            {tx(
              "We keep the stack boring and the thinking rigorous. The goal is software that works — not a wall of framework logos.",
              "Teknoloji yığınını bilinçli olarak sade, düşünceyi titiz tutuyoruz. Amaç çalışan yazılım — framework logolarından bir duvar değil.",
            )}
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2">
          {items.map((item, i) => (
            <Reveal key={item.title} delay={i * 0.07} y={22}>
              <div
                data-testid={`tech-principle-${i + 1}`}
                className="h-full border border-white/10 p-7 transition-colors duration-300 hover:border-white/25 sm:p-8"
              >
                <h3 className="font-display text-lg font-bold tracking-tight text-white">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">
                  {item.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-12 border-t border-white/10 pt-8 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">
            {STACK.join("  —  ")}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
